import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import { BrowserRouter as Link } from "react-router-dom";
import { creaUsuario, obtenerRegionales } from "../Services/Rest";
import Swal from "sweetalert2";
//impoertacion componentes

function CrearUsuario() {
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const [country, setCountry] = useState([]);
  const [countryid, setCountryid] = useState("");
  const [st, setSt] = useState([]);
  const [stateid, setStateid] = useState("");
  useEffect(() => {
    const getcountry = async () => {
      const rescountry = await fetch(obtenerRegionales);
      const rescon = await rescountry.json();
      setCountry(await rescon);
    };
    getcountry();
  }, []);

  const handlecountry = (event) => {
    const getcountryid = event.target.value;
    setCountryid(getcountryid);
  };

  useEffect(() => {
    if (countryid !== "") {
      const getstate = async () => {
        const resstate = await fetch(
          "https://educacionapi.azurewebsites.net/api/ObtenerGestor?Regional=" +
            countryid
        );
        const resst = await resstate.json();
        setSt(await resst);
      };
      getstate();
    }
  }, [countryid]);
  const handlestate = (event) => {
    const getstateid = event.target.value;
    setStateid(getstateid);
  };

  const [postNombre, setPostNombre] = useState([]);
  const [postContrasena, setPostContrasena] = useState([]);
  const [postCorreo, setPostCorreo] = useState([]);
  const [postTipoUsuario, setPostTipoUsuario] = useState([]);
  const [postArea, setPostArea] = useState([]);
  const [postGestorA, setPostGestorA] = useState([]);

  const postData = (e) => {
    e.preventDefault();

    // Validación de campos obligatorios
    if (
      !postNombre ||
      !postContrasena ||
      !postCorreo ||
      !postTipoUsuario ||
      !postArea ||
      !countryid ||
      !postGestorA ||
      !stateid
    ) {
      Swal.fire({
        title: "Campos incompletos",
        text: "Por favor, completa todos los campos obligatorios.",
        icon: "warning",
        timer: 3000,
      });
      return;
    }

    axios({
      auth: { username: "webapp", password: "762tsfsy9826kk87ytttsf" },
      method: "post",
      url: creaUsuario,
      data: {
        nombre: postNombre,
        correo: postCorreo,
        contrasena: postContrasena,
        regional: countryid,
        tipoUsuario: postTipoUsuario,
        area: postArea,
        gestorAsignado: postGestorA,
        correoGestor: stateid,
      },
    })
      .then((Response) => {
        Swal.fire({
          title: "Guardado con éxito!",
          text: "Usuario añadido.",
          icon: "success",
          timer: 3000,
        });
        window.location.reload("/");
      })
      .catch((error) => {
        Swal.fire({
          title: "Error en el envío",
          text: "Ocurrió un problema al guardar. Intenta de nuevo.",
          icon: "error",
          timer: 3000,
        });
      });
  };

  return (
    <div className="test">
      <button
        variant="contained"
        className="btn btn-primary"
        color="primary"
        onClick={handleOpenModalTest}
      >
        {" "}
        Nuevo usuario
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear "
      >
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    Crear Usuario
                  </h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <form className="user">
                      <div className="form-group row">
                        <div className="col-sm-6 mb-3 mb-sm-0">
                          <input
                            type="text"
                            className="form-control form-control-user"
                            placeholder="Nombre"
                            onChange={(e) => setPostNombre(e.target.value)}
                          />
                        </div>
                        <div className="col-sm-6 ">
                          <input
                            type="password"
                            className="form-control form-control-user"
                            placeholder="Contraseña"
                            onChange={(e) => setPostContrasena(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <div className="col-sm-12">
                          <input
                            type="email"
                            className="form-control form-control-user"
                            placeholder="Correo Electronico"
                            onChange={(e) => setPostCorreo(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="form-group row">
                        <div className="col-sm-6 mb-3 mb-sm-0">
                          <select
                            className="btn btn-secondary btn-user btn-block"
                            onChange={(e) => setPostArea(e.target.value)}
                          >
                            <option value="">Seleccione Area</option>
                            <option value="Comercial">Comercial </option>
                            <option value="Educacion">Educación</option>
                          </select>
                        </div>

                        <div className="col-sm-6 ">
                          <select
                            className="btn btn-secondary btn-user btn-block"
                            onChange={(e) => setPostTipoUsuario(e.target.value)}
                          >
                            <option value="">Seleccione Tipo Usuario</option>
                            <option value="1">Administrador </option>
                            <option value="2">Gestor </option>
                            <option value="3">Comercial</option>
                          </select>
                        </div>
                      </div>

                      <div className="form-group row">
                        <div className="col-sm-12">
                          <select
                            className="btn btn-secondary btn-user btn-block text-center"
                            onChange={(e) => handlecountry(e)}
                          >
                            <option value="0">Seleccione regional</option>
                            <option value="No Aplica">No Aplica </option>
                            {country.map((getcon, index) => (
                              <option key={index} value={getcon.correo}>
                                {getcon.nombre}{" "}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="form-group row">
                        <div className="col-sm-6 mb-3 mb-sm-0">
                          <select
                            className="btn btn-secondary btn-user btn-block"
                            onChange={(e) => setPostGestorA(e.target.value)}
                          >
                            <option defaultValue="No Aplica">
                              seleccione gestor
                            </option>
                            <option value={postCorreo}>No Aplica</option>
                            {st.map((item) => (
                              <option value={item.descripcion}>
                                {item.descripcion + " " + item.nombre}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-sm-6">
                          <select
                            className="btn btn-secondary btn-user btn-block"
                            onChange={(e) => handlestate(e)}
                          >
                            <option defaultValue="No Aplica">
                              seleccione correo del gestor
                            </option>
                            <option value={postCorreo}>No Aplica</option>
                            {st.map((getst, index) => (
                              <option key={index} value={getst.correo}>
                                {getst.correo}{" "}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <a>
                        <button
                          className="btn btn-primary btn-user btn-block"
                          type="submit"
                          onClick={postData}
                        >
                          Guardar
                        </button>
                      </a>
                      <hr className="sidebar-divider" />

                      <hr />
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}
export default CrearUsuario;
